import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { DashboardAcompProducaoDashDiario } from "../../../components/classes/DashAcompProducao";

import { useTranslation } from "react-i18next";

export default function ChartProd01(props: ChartProd01Props) {
  const { t } = useTranslation();

  const [seriesMixedChart, setSeriesMixedChart] = useState<{ name: string, type: string, data: number[] }[]>([]);
  const [optionsMixedChart, setOptionsMixedChart] = useState<ApexCharts.ApexOptions>({
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "13",
        fontFamily: "Roboto",
        colors: ['white']
      },
      background: {
        enabled: true,
        foreColor: 'black',
        padding: 4,
        borderRadius: 1,
        borderWidth: 1,
        borderColor: 'black',
        opacity: 0.9,
        dropShadow: {
          enabled: false,
          top: 1,
          left: 1,
          blur: 1,
          color: '#000',
          opacity: 0.45
        }
      },
    },
    plotOptions: {
      bar: {
        dataLabels: {
          orientation: "vertical",
          hideOverflowingLabels: true
        }
      }
    }
  });

  useEffect(() => {
    setSeriesMixedChart(
      [
        {
          name: t("pages.dashboardProductionMonitoring.text.planned"),
          type: "column",
          data: props.data?.quantidadesPlanejadas ?? []
        },
        {
          name: t("pages.dashboardProductionMonitoring.text.produced"),
          type: "column",
          data: props.data?.quantidadesProduzidas ?? []
        }
      ]
    );

    setOptionsMixedChart(
      {
        ...optionsMixedChart,
        xaxis: {
          type: "datetime",
          categories: props.data?.dia?.map(x => new Date(x).toLocaleDateString())
        }
      }
    );
  }, [props]);

  return (
    <div id="chart001" className="mixed-chart">
      <Chart
        options={optionsMixedChart}
        series={seriesMixedChart}
        type="line"
        width={900}
        height={300}
      />
    </div>
  );
}

interface ChartProd01Props {
  data?: DashboardAcompProducaoDashDiario
}